export function InitializeTemperature(
  temperature = { tempMin: '', tempMax: '', tempMinF: '', tempMaxF: '' },
) {
  return {
    ...temperature,
  };
}
